(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[926],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 53290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Progressbar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Progressbar_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77990);
/* harmony import */ var _Progressbar_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Progressbar_module_css__WEBPACK_IMPORTED_MODULE_1__);


var Progressbar = function(param) {
    var _progress = param.progress, progress = _progress === void 0 ? 1 : _progress;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative z-10 w-full h-2 bg-white rounded-full bg-opacity-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute top-0 left-0 h-full bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500 rounded-full ".concat((_Progressbar_module_css__WEBPACK_IMPORTED_MODULE_1___default().animated)),
            style: {
                width: "".concat(progress, "%")
            },
            "data-testid": "progressbar"
        })
    });
};


/***/ }),

/***/ 24539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Checklist; },
  "d": function() { return /* reexport */ ChecklistItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./modules/questionnaire/InfoPage/Description.tsx
var Description = __webpack_require__(34796);
;// CONCATENATED MODULE: ./components/page-sections/Checklist/Checklist.tsx




function ChecklistItem(param) {
    var checklist = param.checklist;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-6 md:p-8 flex-1", {
            "bg-white bg-opacity-5 rounded-xl": checklist.highlighted
        }),
        children: [
            checklist.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xl leading-6 text-center md:text-2xl md:leading-8",
                children: checklist.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: classnames_default()("flex flex-col space-y-8", {
                    "mt-4": checklist.title
                }),
                children: (checklist === null || checklist === void 0 ? void 0 : checklist.checklistItems) && checklist.checklistItems.map(function(checklistItem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex text-base md:text-xl md:leading-8 font-inter",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4",
                                children: checklistItem.checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "mt-1 lg:mt-2",
                                    width: "19",
                                    height: "14",
                                    viewBox: "0 0 19 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M1.5 7L7.5 13L17.5 1",
                                        stroke: "#FF8F5B",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6 mt-1",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M5.29303 5.29299C5.48056 5.10552 5.73487 5.0002 6.00003 5.0002C6.26519 5.0002 6.5195 5.10552 6.70703 5.29299L12 10.586L17.293 5.29299C17.3853 5.19748 17.4956 5.1213 17.6176 5.06889C17.7396 5.01648 17.8709 4.98889 18.0036 4.98774C18.1364 4.98659 18.2681 5.01189 18.391 5.06217C18.5139 5.11245 18.6255 5.1867 18.7194 5.28059C18.8133 5.37449 18.8876 5.48614 18.9379 5.60904C18.9881 5.73193 19.0134 5.86361 19.0123 5.99639C19.0111 6.12917 18.9835 6.26039 18.9311 6.38239C18.8787 6.5044 18.8025 6.61474 18.707 6.70699L13.414 12L18.707 17.293C18.8892 17.4816 18.99 17.7342 18.9877 17.9964C18.9854 18.2586 18.8803 18.5094 18.6948 18.6948C18.5094 18.8802 18.2586 18.9854 17.9964 18.9877C17.7342 18.9899 17.4816 18.8891 17.293 18.707L12 13.414L6.70703 18.707C6.51843 18.8891 6.26583 18.9899 6.00363 18.9877C5.74143 18.9854 5.49062 18.8802 5.30521 18.6948C5.1198 18.5094 5.01464 18.2586 5.01236 17.9964C5.01008 17.7342 5.11087 17.4816 5.29303 17.293L10.586 12L5.29303 6.70699C5.10556 6.51946 5.00024 6.26515 5.00024 5.99999C5.00024 5.73483 5.10556 5.48052 5.29303 5.29299Z",
                                        fill: "#BBBDC5"
                                    })
                                })
                            }),
                            checklistItem.text
                        ]
                    }, checklistItem._key);
                })
            })
        ]
    });
}
function Checklist(param) {
    var title = param.title, text = param.text, gradient = param.gradient, checklists = param.checklists;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("overflow-hidden ", {
            "bg-dawnDark-700": gradient
        }),
        children: [
            gradient && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-50rem",
                        top: "2rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 6,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "2rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        right: "-50rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-50rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: classnames_default()("relative flex justify-center text-white", {
                    "py-20 md:py-30": title.length > 1
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("lg:mx-4", "".concat(checklists.length > 1 ? "max-w-6xl" : "max-w-2xl")),
                    children: [
                        title.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2.5xl leading-8 md:text-5xl font-semibold text-center md:leading-14",
                            children: title
                        }),
                        text != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* Description */.d, {
                                children: text[0].children[0].text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("mt-8 ", {
                                "flex flex-col space-y-4 md:space-y-0 md:space-x-8 md:flex-row": checklists.length > 1
                            }),
                            children: checklists && checklists.map(function(checklist) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistItem, {
                                    checklist: checklist
                                }, checklist._key);
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Checklist/index.ts



/***/ }),

/***/ 39021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ TestimonialCarousel; },
  "H": function() { return /* reexport */ Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js
var embla_carousel_react_esm = __webpack_require__(25585);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/page-sections/Testimonials/Testimonials.tsx






var tailwindScreenBreakpoins = (tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.screens */.r.screens) || {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};
function DotButton(param) {
    var isSelected = param.isSelected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "Toggle testimonial",
        onClick: onClick,
        className: "w-2 h-2 rounded-full ".concat(isSelected ? "bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500" : "bg-white bg-opacity-5")
    });
}
function TestimonialBox(param) {
    var text = param.text, source = param.source, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("relative flex-grow-0 flex-shrink-0 w-10/12 px-2 md:px-4 md:w-4/6 xl:w-1/3 md:pr-4 xl:pr-8", {
            "opacity-40 xl:opacity-100": !isActive
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-between h-full p-8 bg-white bg-opacity-5 rounded-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-lg leading-8 text-white md:text-2xl md:leading-10 font-inter",
                        children: [
                            "\u201C",
                            text,
                            "\u201D"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center mt-4 space-x-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium",
                            children: [
                                "- ",
                                source
                            ]
                        })
                    })
                })
            ]
        })
    });
}
function getActiveBreakpoints(breakpoints) {
    return Object.keys(breakpoints).filter(function(breakpoint) {
        return window.matchMedia("(min-width: ".concat(breakpoints[breakpoint], ")")).matches;
    });
}
function createEmblaCarouselConfig() {
    var activeBreakpoints = getActiveBreakpoints(tailwindScreenBreakpoins);
    var slidesToScroll = activeBreakpoints.includes("xl") ? 3 : 1;
    return {
        slidesToScroll: slidesToScroll,
        draggable: slidesToScroll <= 2,
        align: "center",
        startIndex: 1,
        loop: true
    };
}
function Testimonials(param) {
    var _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "py-16 bg-dawnDark-700 md:py-30",
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "mx-8 text-3xl font-semibold text-center text-white md:text-5xl md:text-left",
                    children: [
                        "More Sleep.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden"
                        }),
                        " Less Worries."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {})
        ]
    });
}
function TestimonialCarousel() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)(), 2), emblaCarouselRef = ref[0], emblaCarousel = ref[1];
    var ref1 = (0,react.useState)([]), scrollSnaps = ref1[0], setScrollSnaps = ref1[1];
    var ref2 = (0,react.useState)(1), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var onSelect = (0,react.useCallback)(function() {
        if (!emblaCarousel) {
            return;
        }
        setSelectedIndex(emblaCarousel.selectedScrollSnap());
    }, [
        emblaCarousel,
        setSelectedIndex
    ]);
    var scrollTo = (0,react.useCallback)(function(index) {
        return emblaCarousel && emblaCarousel.scrollTo(index);
    }, [
        emblaCarousel
    ]);
    (0,react.useEffect)(function() {
        if (!emblaCarousel) {
            return;
        }
        setScrollSnaps(emblaCarousel.scrollSnapList());
        emblaCarousel.reInit(createEmblaCarouselConfig());
        emblaCarousel.on("select", onSelect);
        emblaCarousel.on("resize", function() {
            emblaCarousel.reInit(createEmblaCarouselConfig());
        });
    }, [
        emblaCarousel,
        setScrollSnaps,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: emblaCarouselRef,
                    className: "overflow-hidden max-w-7xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "The only approach that has tangibly improved my mental health in the long run. It is simple, long-lasting and sustainable.",
                                source: "Ilya V.",
                                isActive: selectedIndex === 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I've spent a lot of money trying different things for my mental health. Dawn's CBT program was the only thing that made a difference.",
                                source: "Kevin L.",
                                isActive: selectedIndex === 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I have been falling asleep within 10-15 mins. Dawn has been a huge improvement to my life and I\u2019m really glad I gave it a try.",
                                source: "Andrew K.",
                                isActive: selectedIndex === 2
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-4 xl:hidden pb-9 md:pb-28 xl:pb-52",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex space-x-2",
                    children: scrollSnaps.map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotButton, {
                            onClick: function() {
                                return scrollTo(index);
                            },
                            isSelected: selectedIndex === index
                        }, index);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Testimonials/index.ts



/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 34796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Description = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "text-base leading-8 text-center max-w-4xl lg:text-xl lg:leading-8 font-inter",
        children: children
    });
};


/***/ }),

/***/ 39397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ Question; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./modules/questionnaire/Question/Question.tsx

function Question(param) {
    var text = param.text, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pb-2 max-w-4xl text-2.5xl font-semibold leading-10 lg:leading-14 text-white md:text-5xl",
                children: text
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "md:text-xl text-dawnDark-300 font-inter",
                children: description
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/questionnaire/Question/index.ts



/***/ }),

/***/ 60926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ QuestionnairePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/factory/createStateContext.js

var createStateContext = function (defaultInitialValue) {
    var context = (0,react.createContext)(undefined);
    var providerFactory = function (props, children) { return (0,react.createElement)(context.Provider, props, children); };
    var StateProvider = function (_a) {
        var children = _a.children, initialValue = _a.initialValue;
        var state = (0,react.useState)(initialValue !== undefined ? initialValue : defaultInitialValue);
        return providerFactory({ value: state }, children);
    };
    var useStateContext = function () {
        var state = (0,react.useContext)(context);
        if (state == null) {
            throw new Error("useStateContext must be used inside a StateProvider.");
        }
        return state;
    };
    return [useStateContext, StateProvider, context];
};
/* harmony default export */ var factory_createStateContext = (createStateContext);

;// CONCATENATED MODULE: ./utils/context.ts


var ref = (0,_sliced_to_array/* default */.Z)(factory_createStateContext({}), 2);
var useSharedState = ref[0], SharedStateProvider = ref[1];

// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/groq/lib/groq.js
var groq = __webpack_require__(12870);
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);
;// CONCATENATED MODULE: ./groq-queries/questionnaire.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "*[_type == 'questionnaire'&& slug.current == $slug][0]"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "*[_type == 'questionnaire' && defined(slug)]{ slug }"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var questionnaireQuery = groq_default()(_templateObject());
var questionnairePathsQuery = groq_default()(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(66089);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMeasure.js + 2 modules
var useMeasure = __webpack_require__(91672);
// EXTERNAL MODULE: ./components/DawnLogo/DawnLogo.tsx
var DawnLogo = __webpack_require__(96387);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./modules/questionnaire/Question/index.ts + 1 modules
var Question = __webpack_require__(39397);
;// CONCATENATED MODULE: ./modules/questionnaire/Inputs/TextInput.tsx







var TextInput = function(param) {
    var questionKey = param.questionKey;
    // eslint-disable-next-line no-unused-vars
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 2), sharedState = ref[0], setSharedState = ref[1];
    var answer = sharedState[questionKey] || "";
    var handleChange = (0,react.useCallback)(function(e) {
        setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), (0,_define_property/* default */.Z)({}, questionKey, e.target.value)));
    }, [
        questionKey,
        setSharedState,
        sharedState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        className: "w-full p-4 mb-4 text-sm text-white border rounded-full bg-dawnDark-700 border-dawnDark-400 placeholder-dawnDark-300 focus:outline-none",
        placeholder: "Enter your answer",
        value: answer,
        onChange: handleChange
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/Inputs/RadioInput.tsx








var RadioInput = function(param) {
    var options = param.options, questionKey = param.questionKey;
    // eslint-disable-next-line no-unused-vars
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 2), sharedState = ref[0], setSharedState = ref[1];
    var answer = sharedState[questionKey] || false;
    var handleChange = (0,react.useCallback)(function(e) {
        setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), (0,_define_property/* default */.Z)({}, questionKey, e.target.value)));
    }, [
        questionKey,
        setSharedState,
        sharedState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: options.map(function(opt, i) {
            var checked = answer === opt.text;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "".concat(questionKey, "-").concat(i),
                className: classnames_default()("hover:bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500 bg-dawnDark-400 p-px rounded-full lg:flex-1 lg:min-w-1/2 min-w-full h-16 leading-14 z-50 block", {
                    "bg-gradient-to-bl": checked,
                    "xl:col-span-2": options.length % 2 === 1 && i === options.length - 1
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center w-full h-full py-3 text-sm text-left rounded-full bg-dawnDark-700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            value: opt.text,
                            id: "".concat(questionKey, "-").concat(i),
                            "data-testid": "radio-".concat(questionKey, "-").concat(i),
                            className: "hidden",
                            name: questionKey,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-4 mb-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("h-4 w-4  from-dawnOrange-500 to-dawnPurple-500 flex items-center justify-center rounded-full", {
                                    "border border-dawnDark-300 ": !checked,
                                    "bg-gradient-to-bl ": checked
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-dawnDark-700 h-1.5 w-1.5 rounded-full"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-full text-base md:text-lg font-inter",
                            children: opt.text
                        })
                    ]
                })
            }, opt.text);
        })
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/Inputs/Checkbox.tsx








var CheckboxInput = function(param) {
    var questionKey = param.questionKey, options = param.options;
    // eslint-disable-next-line no-unused-vars
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 2), sharedState = ref[0], setSharedState = ref[1];
    var answer = sharedState[questionKey];
    var handleCheckboxChange = (0,react.useCallback)(function(e) {
        var currentAnswers = sharedState[questionKey] || [];
        var index = currentAnswers.findIndex(function(item) {
            return item === e.target.value;
        });
        if (index < 0 && e.target.checked === true) {
            // The selected item doesn't exist in array - so Add to array
            currentAnswers.push(e.target.value);
            setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), (0,_define_property/* default */.Z)({}, questionKey, currentAnswers)));
        } else if (index >= 0 && e.target.checked === false) {
            currentAnswers.splice(index, 1);
            setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), (0,_define_property/* default */.Z)({}, questionKey, currentAnswers)));
        }
    }, [
        questionKey,
        setSharedState,
        sharedState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: options.map(function(opt, i) {
            var checked = Array.isArray(answer) ? answer.includes(opt.text) : false;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "".concat(questionKey, "-").concat(i),
                className: classnames_default()("md:hover:bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500 bg-dawnDark-400 p-px rounded-full lg:flex-1 lg:min-w-1/3 min-w-full h-16 leading-14 z-50 block", {
                    "bg-gradient-to-bl": checked,
                    "xl:col-span-2": options.length % 2 === 1 && i === options.length - 1
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-center w-full h-full p-4 text-center rounded-full bg-dawnDark-700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            checked: checked,
                            onChange: handleCheckboxChange,
                            value: opt.text,
                            id: "".concat(questionKey, "-").concat(i),
                            "data-testid": "".concat(questionKey, "-").concat(i),
                            className: "hidden"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "w-full text-base md:text-lg font-inter",
                            children: opt.text
                        })
                    ]
                })
            }, opt.text);
        })
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/Inputs/SelectInput.tsx







function SelectInput(param) {
    var questionKey = param.questionKey, options = param.options;
    // eslint-disable-next-line no-unused-vars
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 2), sharedState = ref[0], setSharedState = ref[1];
    var answer = sharedState[questionKey] || "";
    var onChange = (0,react.useCallback)(function(event) {
        setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), (0,_define_property/* default */.Z)({}, questionKey, event.target.value)));
    }, [
        questionKey,
        setSharedState,
        sharedState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
            onChange: onChange,
            value: answer,
            className: "w-full max-w-xl px-6 py-4 border rounded-full bg-dawnDark-700 border-dawnDark-400 focus:outline-none placeholder-dawnDark-300",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: "",
                    disabled: true,
                    selected: true,
                    hidden: true,
                    children: "Please select"
                }),
                options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        children: option.text
                    }, index);
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./modules/questionnaire/SingleQuestion/SingleQuestion.tsx







function SingleQuestion(param) {
    var id = param.id, question = param.question, description = param.description, optionType = param.optionType, _options = param.options, options = _options === void 0 ? [] : _options;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center w-full px-6 text-center whitespace-normal lg:px-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full pb-6 lg:w-1/2 md:pb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                    text: question,
                    description: description ? description : optionType === "checkbox" ? "Choose as many as you like" : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex-grow w-full lg:w-6/12 flex flex-wrap gap-4 pb-18 lg:pb-12", {
                    "xl:grid xl:grid-cols-2": options.length > 4 && optionType !== "select"
                }),
                children: [
                    optionType === "text" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput, {
                        questionKey: id
                    }),
                    optionType === "radio" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput, {
                        questionKey: id,
                        options: options
                    }),
                    optionType === "checkbox" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput, {
                        questionKey: id,
                        options: options
                    }),
                    optionType === "select" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInput, {
                        questionKey: id,
                        options: options
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/questionnaire/SingleQuestion/index.ts


// EXTERNAL MODULE: ./components/Progressbar/Progressbar.tsx
var Progressbar = __webpack_require__(53290);
// EXTERNAL MODULE: ./modules/questionnaire/Carousel/carousel.module.css
var carousel_module = __webpack_require__(57441);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
;// CONCATENATED MODULE: ./modules/questionnaire/Carousel/Carousel.tsx





function CarouselItem(param) {
    var children = param.children, _width = param.width, width = _width === void 0 ? "100vw" : _width, index = param.index, activeIndex = param.activeIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (carousel_module_default()).carouselItem,
        style: {
            width: width,
            height: index == activeIndex ? "auto" : 0
        },
        children: children
    });
}
function Carousel(param) {
    var children = param.children, _activeIndex = param.activeIndex, activeIndex = _activeIndex === void 0 ? 0 : _activeIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (carousel_module_default()).carousel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (carousel_module_default()).inner,
            style: {
                transform: "translateX(-".concat(activeIndex * 100, "vw)")
            },
            children: react.Children.map(children, function(child) {
                // @ts-ignore
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.props), {
                    activeIndex: activeIndex
                }));
            })
        })
    });
}
/* harmony default export */ var Carousel_Carousel = ((/* unused pure expression or super */ null && (Carousel)));

;// CONCATENATED MODULE: ./modules/questionnaire/Carousel/index.ts


// EXTERNAL MODULE: ./utils/storage.ts
var storage = __webpack_require__(45644);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./modules/questionnaire/InfoPage/Description.tsx
var Description = __webpack_require__(34796);
// EXTERNAL MODULE: ./node_modules/next-sanity-image/dist/index.js
var dist = __webpack_require__(61202);
;// CONCATENATED MODULE: ./modules/questionnaire/InfoPage/InfoImage.tsx



var InfoImage = function(param) {
    var image = param.image;
    var imageProps = (0,dist/* useNextSanityImage */.J)(sanity/* sanityClient */.i3, image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imageProps === null || imageProps === void 0 ? void 0 : imageProps.src,
        className: "w-14 h-14",
        alt: ""
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/InfoPage/DescriptionImage.tsx



var DescriptionImage = function(param) {
    var image = param.image;
    var imageProps = (0,dist/* useNextSanityImage */.J)(sanity/* sanityClient */.i3, image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imageProps === null || imageProps === void 0 ? void 0 : imageProps.src,
        alt: "",
        height: 30,
        width: 130
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/InfoPage/Title.tsx

var Title = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: "text-2.5xl max-w-4xl font-semibold text-center lg:text-5xl leading-10 lg:leading-14 ",
        children: children
    });
};

;// CONCATENATED MODULE: ./modules/questionnaire/InfoPage/Page.tsx








var InfoPageComponent = function(param) {
    var content = param.content;
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 1), sharedState = ref[0];
    var getStyles = function() {
        if (content.infoPageType !== "testimonial" && sharedState["contentAxes"]) {
            return {
                height: sharedState["contentAxes"].height - 80,
                justifyContent: "md:center"
            };
        }
        return {};
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center w-full max-w-8xl text-center whitespace-normal lg:px-20",
        style: getStyles(),
        children: [
            content.infoPageType === "testimonial" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: content.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-full text-left pt-4 lg:pt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                    })
                ]
            }),
            content.infoPageType !== "testimonial" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-4xl px-6 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: content.title
                    }),
                    content.image != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoImage, {
                            image: content.image
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* Description */.d, {
                            children: content.text[0].children[0].text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 w-full md:grid-cols-4 gap-y-6 place-items-center pt-10",
                        children: content.text.filter(function(item) {
                            return item.children == null;
                        }).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionImage, {
                                    image: item
                                }, item._key)
                            });
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./modules/questionnaire/ContinueButton/index.ts + 1 modules
var ContinueButton = __webpack_require__(7720);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Checklist/index.ts + 1 modules
var Checklist = __webpack_require__(24539);
// EXTERNAL MODULE: ./hooks/useGetInsuranceData.ts
var useGetInsuranceData = __webpack_require__(13433);
;// CONCATENATED MODULE: ./modules/questionnaire/Questionnaire/Questionnaire.tsx






/* eslint-disable max-lines */ 
















function Questionnaire(param) {
    var questionnaire = param.questionnaire;
    var continueAction = function continueAction(event) {
        document.getElementById("top").scrollIntoView();
        event.preventDefault();
        var currentState = sharedState[getQuestionKey(currentPage)];
        var currentQuestionType = getQuestionType(currentPage);
        if (currentQuestionType === "question" && !currentState) return;
        var answer = currentState;
        var answersObj = (0,storage/* getFromStorage */.L)(constants/* QUESTIONNAIRE_LOCALSTORAGE_KEY */.LV);
        answersObj[getQuestionKey(currentPage)] = {
            question: currentQuestionObject.text,
            answer: answer,
            questionnaireSlug: questionnaire.slug.current,
            questionSlug: currentQuestionObject.slug.current
        };
        (0,storage/* saveToStorage */.R)(constants/* QUESTIONNAIRE_LOCALSTORAGE_KEY */.LV, answersObj);
        if (currentQuestionObject._type === "question" && currentQuestionObject.optionType === "radio") {
            var selectedOption = currentQuestionObject.options.find(function(opt) {
                return opt.text === answer;
            });
            if (selectedOption && selectedOption.continueUrl && selectedOption.continueUrl !== "") {
                return handleNext({
                    nextUrl: selectedOption.continueUrl,
                    answersObj: answersObj
                });
            }
        }
        handleNext({
            answersObj: answersObj
        });
    };
    var handleNext = function handleNext(param) {
        var nextUrl = param.nextUrl, answersObj = param.answersObj;
        var routerQuery = (0,_object_spread/* default */.Z)({}, router.query);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Add insurance data to query params.
            for(var _iterator = Object.values(answersObj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value.questionSlug === "insurance-state" || value.questionSlug === "insurance-plan-type" || value.questionSlug === "insurance-plan" && value.answer) {
                    routerQuery[value.questionSlug] = value.answer.toString();
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (nextUrl) {
            router.push({
                pathname: nextUrl,
                query: (0,_object_spread/* default */.Z)({}, routerQuery)
            });
        } else if (!contentPages[currentPage + 1]) {
            // Questionnaire complete
            delete router.query[constants/* SLUG_KEY */.BW];
            router.push({
                pathname: getCompletePagePathname(questionnaire.completePageSlug, isEligibleForInsurance, residesInSupportedState),
                query: routerQuery
            });
            return;
        } else {
            delete routerQuery.slug;
            router.push({
                pathname: "/questionnaire/".concat(questionnaire.slug.current),
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routerQuery), (0,_define_property/* default */.Z)({}, constants/* SLUG_KEY */.BW, contentPages[currentPage + 1].slug.current))
            });
        }
    };
    var ref = (0,_sliced_to_array/* default */.Z)(useSharedState(), 2), sharedState = ref[0], setSharedState = ref[1];
    var router = (0,next_router.useRouter)();
    var contentPages = (0,react.useMemo)(function() {
        return (questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.content) || [];
    }, [
        questionnaire
    ]);
    var currentPage = contentPages.findIndex(function(page) {
        return page.slug.current === router.query[constants/* SLUG_KEY */.BW];
    });
    var currentQuestionObject = contentPages[currentPage];
    var getQuestionKey = (0,react.useCallback)(function(index) {
        var ref;
        return (ref = contentPages[index]) === null || ref === void 0 ? void 0 : ref._key;
    }, [
        contentPages
    ]);
    var getQuestionType = (0,react.useCallback)(function(index) {
        var ref;
        return (ref = contentPages[index]) === null || ref === void 0 ? void 0 : ref._type;
    }, [
        contentPages
    ]);
    var sharedStateToAnswers = function() {
        var ref;
        return (ref = sharedState.allQuestions) === null || ref === void 0 ? void 0 : ref.reduce(function(all, question) {
            all[question._key] = {
                question: question.text,
                answer: sharedState[question._key],
                questionnaireSlug: questionnaire.slug.current,
                questionSlug: question.slug.current
            };
            return all;
        }, {});
    };
    var currentAnswer = sharedState[getQuestionKey(currentPage)] || "";
    var ref1 = (0,useGetInsuranceData/* useGetInsuranceData */.e)(sharedStateToAnswers()), isEligibleForInsurance = ref1.isEligibleForInsurance, residesInSupportedState = ref1.residesInSupportedState;
    var isContinueButtonEnabled = getQuestionType(currentPage) === "infoPage" || getQuestionType(currentPage) === "checklistPageSection" || currentAnswer && currentAnswer.length > 0 && currentAnswer !== false;
    var prevQuestion = (0,react.useMemo)(function() {
        if (!contentPages) {
            return null;
        }
        var currentPageIndex = contentPages === null || contentPages === void 0 ? void 0 : contentPages.findIndex(function(page) {
            return page.slug.current === router.query[constants/* SLUG_KEY */.BW];
        });
        if (currentPageIndex > 0) {
            return contentPages[currentPageIndex - 1].slug.current;
        }
        return contentPages[0].slug.current;
    }, [
        contentPages,
        router.query
    ]);
    var handleBack = (0,react.useCallback)(function() {
        router.push({
            pathname: "/questionnaire/".concat(questionnaire.slug.current),
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), (0,_define_property/* default */.Z)({}, constants/* SLUG_KEY */.BW, prevQuestion))
        });
    }, [
        prevQuestion,
        router,
        questionnaire.slug
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMeasure/* default */.Z)(), 2), contentRef = ref2[0], contentAxes = ref2[1];
    (0,react.useEffect)(function() {
        setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedState), {
            contentAxes: contentAxes
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentAxes,
        setSharedState
    ]);
    (0,react.useEffect)(function() {
        // set the global state
        var answersObj = (0,storage/* getFromStorage */.L)(constants/* QUESTIONNAIRE_LOCALSTORAGE_KEY */.LV);
        var ans = {};
        contentPages.forEach(function(page) {
            var ref;
            ans[page._key] = (ref = answersObj[page._key]) === null || ref === void 0 ? void 0 : ref.answer;
        });
        setSharedState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ans), {
            allQuestions: contentPages
        }));
    }, [
        contentPages,
        setSharedState
    ]);
    (0,react.useEffect)(function() {
        if (!router.asPath.includes("".concat(constants/* SLUG_KEY */.BW, "="))) {
            // Append first page query param if it doesn't exist.
            // NOTE: We can also redirect the user to last answered question here
            router.replace({
                pathname: window.location.pathname,
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), (0,_define_property/* default */.Z)({}, constants/* SLUG_KEY */.BW, contentPages[0].slug.current))
            });
        }
    // Note: redirecting the user to last answered question is probably useless here as the slug could change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath
    ]);
    var progress = (0,react.useMemo)(function() {
        if (router.query[constants/* SLUG_KEY */.BW] && contentPages.length) {
            return +currentPage / contentPages.length * 100;
        }
        return 1;
    }, [
        router.query,
        contentPages,
        currentPage
    ]);
    var isInvalidScreen = (0,react.useMemo)(function() {
        // This function checks whether the questionnaire is completed by the user
        return router.query[constants/* SLUG_KEY */.BW] && currentPage < 0;
    }, [
        router.query,
        currentPage
    ]);
    var Questions = (0,react.useMemo)(function() {
        return contentPages.map(function(page, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselItem, {
                index: index,
                children: [
                    page._type === "question" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleQuestion, {
                        id: page._key,
                        question: page.text,
                        description: page.description,
                        optionType: page.optionType,
                        options: page.options
                    }),
                    page._type === "checklistPageSection" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center w-full px-6 whitespace-normal max-w-8xl lg:px-20 lg:py-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: page.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checklist/* Checklist */.W, {
                                title: "",
                                text: page.text,
                                gradient: page.gradient,
                                checklists: page.checklists
                            })
                        ]
                    }),
                    page._type === "infoPage" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPageComponent, {
                        content: page
                    })
                ]
            }, page._key);
        });
    }, [
        contentPages
    ]);
    if (isInvalidScreen) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), (0,_define_property/* default */.Z)({}, constants/* SLUG_KEY */.BW, contentPages[0].slug.current))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "jsx-8e4bb1af736072b2" + " " + "relative h-full min-h-screen overflow-hidden text-white bg-dawnDark-700",
        children: [
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "8e4bb1af736072b2",
                children: "body{background-color:rgba(17,22,30,1);height:100vh}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8e4bb1af736072b2" + " " + "relative z-0 hidden xl:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8e4bb1af736072b2" + " " + "flex-grow bg-dawnDark-700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "top",
                        className: "jsx-8e4bb1af736072b2" + " " + "px-6 lg:px-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/gradient-ellipsis-1.svg",
                                alt: "",
                                className: "jsx-8e4bb1af736072b2" + " " + "absolute top-0 z-0 -right-40"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-8e4bb1af736072b2" + " " + "relative z-10 flex items-center justify-center py-5 md:py-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DawnLogo/* Logo */.T, {})
                            }),
                            ((currentQuestionObject === null || currentQuestionObject === void 0 ? void 0 : currentQuestionObject._type) == "question" || currentPage > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Progressbar/* Progressbar */.c, {
                                progress: progress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: contentRef,
                        className: "jsx-8e4bb1af736072b2" + " " + "relative z-10 h-full pt-10 md:pt-14 pb-22",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-8e4bb1af736072b2" + " " + "h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                                activeIndex: currentPage,
                                children: Questions
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-8e4bb1af736072b2" + " " + "fixed bottom-0 z-10 flex justify-center w-full px-6 backdrop-filter backdrop-blur-1.5xl border-t border-dawnDark-500 lg:border-t-0 lg:px-20 lg:py-5 lg:mb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-8e4bb1af736072b2" + " " + "flex flex-row w-full py-3 lg:w-1/3 lg:py-0 z-5",
                    children: [
                        prevQuestion !== router.query[constants/* SLUG_KEY */.BW] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-8e4bb1af736072b2" + " " + "relative z-10 flex items-center justify-center w-20 mr-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: handleBack,
                                className: "jsx-8e4bb1af736072b2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-8e4bb1af736072b2" + " " + "flex items-center md:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/back.svg",
                                            alt: "back-icon",
                                            height: 52,
                                            width: 52
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-8e4bb1af736072b2" + " " + "hidden md:block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/back.svg",
                                            alt: "back-icon",
                                            height: 64,
                                            width: 64
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-8e4bb1af736072b2" + " " + "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContinueButton/* ContinueButton */.f, {
                                action: continueAction,
                                disabled: !isContinueButtonEnabled
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function getCompletePagePathname(completePageSlug, isEligibleForInsurance, residesInEligibleState) {
    if (isEligibleForInsurance) {
        return "/account/schedule-call";
    }
    if (!residesInEligibleState) {
        return "/unsupported-state";
    }
    if (!completePageSlug) {
        return "/questionnaire/email-prompt";
    }
    if (completePageSlug.startsWith("/")) {
        return completePageSlug;
    }
    return "/questionnaire/".concat(completePageSlug);
}

;// CONCATENATED MODULE: ./modules/questionnaire/Questionnaire/index.ts


;// CONCATENATED MODULE: ./pages/questionnaire/[slug].tsx






var __N_SSG = true;
function QuestionnairePage(param) {
    var data = param.data, preview = param.preview;
    var ref, ref1;
    var ref2 = (0,sanity/* usePreviewSubscription */.$r)(questionnaireQuery, {
        params: {
            slug: (ref = data.questionnaire) === null || ref === void 0 ? void 0 : ref.slug.current
        },
        initialData: data.questionnaire,
        enabled: preview && ((ref1 = data.questionnaire) === null || ref1 === void 0 ? void 0 : ref1.slug)
    }), questionnaire = ref2.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            questionnaire.title,
                            " | Dawn Health"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Dawn health ".concat(questionnaire.title.toLowerCase())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedStateProvider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Questionnaire, {
                    questionnaire: questionnaire
                })
            })
        ]
    });
};


/***/ }),

/***/ 77990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animated":"Progressbar_animated__sdvjJ"};

/***/ }),

/***/ 57441:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__dBvqE","inner":"carousel_inner__CEtR0","carouselItem":"carousel_carouselItem__Z8wIR"};

/***/ }),

/***/ 91672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useMeasure; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js


var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMeasure.js



var defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
function useMeasure() {
    var _a = (0,react.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0,react.useState)(defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0,react.useMemo)(function () {
        return new window.ResizeObserver(function (entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({ x: x, y: y, width: width, height: height, top: top_1, left: left, bottom: bottom, right: right });
            }
        });
    }, []);
    esm_useIsomorphicLayoutEffect(function () {
        if (!element)
            return;
        observer.observe(element);
        return function () {
            observer.disconnect();
        };
    }, [element]);
    return [ref, rect];
}
/* harmony default export */ var esm_useMeasure = (isBrowser && typeof window.ResizeObserver !== 'undefined'
    ? useMeasure
    : (function () { return [noop, defaultState]; }));


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);